

import Vue from 'vue'
import App from './App'
import '@/config/vux.js'
import '@/assets/common.less'
import '@/assets/iconfont.css'
import router from './config/router'
import store from './config/vuex'
import axios from './config/axios'
import '@/components/common/tool.js'
import '@/components/common/simpleComponent.js'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import VueClipboard from 'vue-clipboard2'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'


Vue.use(WechatPlugin)
Vue.use(Viewer, {
defaultOptions: {
zIndex: 9999,
}
})
Viewer.setDefaults({
navbar: false,
title: false,
toolbar: false,
toggleOnDblclick: false
})


Vue.config.productionTip = false
Vue.use(VueClipboard)

const FastClick = require('fastclick')
FastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js